import {IEntreprisesRepository} from "../types.ts";

export default function EntrepriseRow({entreprise}: { entreprise: IEntreprisesRepository }) {
  const industryTypes: Array<string> = entreprise.type_industry.split(';').filter((sector) => sector !== '');
  const operationTypes: Array<string> = entreprise.type_operation.split(';').filter((sector) => sector !== '');

  return (
    <a href={entreprise.url}
       className="entreprise-row tw-no-underline tw-p-4 tw-transition tw-flex tw-gap-4 tw-bg-white tw-shadow hover:tw-shadow-md tw-cursor-pointer">
      <img src={entreprise.image} alt={entreprise.name} width={164} height={164}/>
      <div className={'tw-flex tw-flex-col tw-gap-2 [&>p]:tw-m-0'}>
        <p className={'tw-text-2xl entreprise-name'}>{entreprise.name}</p>
        <p>{entreprise.description}</p>
        {(industryTypes.length > 0 || operationTypes.length > 0) &&
          <div className={'pills-container'}>
            {industryTypes.length > 0 && industryTypes.map((type) => <span>{type}</span>)}
            {operationTypes.length > 0 && operationTypes.map((operation) => <span>{operation}</span>)}
          </div>
        }
      </div>
    </a>
  )
}